import React from 'react';

// NOTA: Sección temporalmente oculta hasta que Zenex tenga proyectos reales para mostrar
// Esta es una empresa nueva sin proyectos completados aún
// Para habilitar esta sección en el futuro, restaurar el código original

const Projects = () => {
  return null;
};

export default Projects;
